// extracted by mini-css-extract-plugin
export var csatScore = "_np-5";
export var header = "_np-1";
export var panelWrapper = "_np-2";
export var postPreview = "_np-3";
export var rightContent = "_np-0";
export var wrappingText = "_np-4";